'use es6';

import PropTypes from 'prop-types';
import I18n from 'I18n';
import partial from 'transmute/partial';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import { FolderNavItem } from 'foundations-components/transitional/components/FolderNav';
import { FileIcon } from 'foundations-assets/icons/components/FileIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const getEmptyFolder = () => SearchResultRecord({
  name: I18n.text('salesContentIndexUI.tableRowHoverButtons.noFolder'),
  contentId: 0
});
const FolderNavNoFolderItem = ({
  isInitialFetchLoading,
  setSelectedFolder
}) => {
  if (isInitialFetchLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(FolderNavItem, {
    open: false,
    value: 0,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.tableRowHoverButtons.noFolder"
    }),
    onClick: partial(setSelectedFolder, getEmptyFolder()),
    iconLeft: FileIcon
  }, "no-folder-item");
};
FolderNavNoFolderItem.propTypes = {
  isInitialFetchLoading: PropTypes.bool.isRequired,
  setSelectedFolder: PropTypes.func.isRequired
};
export default FolderNavNoFolderItem;